var _defs, _rect, _text, _text2, _rect2, _text3, _text4, _rect3, _text5, _circle, _text6, _circle2, _text7, _rect4, _text8, _text9, _text10, _text11, _line, _rect5, _text12, _text13, _rect6, _text14, _circle3, _text15, _circle4, _text16, _rect7, _text17, _text18, _text19, _text20, _line2, _rect8, _text21, _text22, _rect9, _text23, _circle5, _text24, _circle6, _text25, _rect10, _text26, _text27, _text28, _text29, _text30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase5Fig2CredentialTopology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 580",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arr",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1 L 9 5 L 0 9 z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1120,
    height: 580,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Credential topology across the pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Local and CI hold no secrets and run in memory. The production build already holds its runtime credential.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 120,
    width: 290,
    height: 300,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 150,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "LOCAL GATE")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 178,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Pre-push hook")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 194,
    width: 158,
    height: 28,
    rx: 14,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 213,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "secrets held: none")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 248,
    r: 2.5,
    fill: "#6B7F74"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 252,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "full test suite before every push")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 270,
    r: 2.5,
    fill: "#6B7F74"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 274,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "zero production access")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 310,
    width: 250,
    height: 94,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1,
    strokeDasharray: "6 4"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 342,
    fontSize: 13,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "in-memory database")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 362,
    fontSize: 12,
    fill: "#4A5F56"
  }, "created per test run,")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 379,
    fontSize: 12,
    fill: "#4A5F56"
  }, "discarded when the run ends")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 376,
    y: 256,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "PUSH")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 344,
    y1: 270,
    x2: 405,
    y2: 270,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 120,
    width: 290,
    height: 300,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 435,
    y: 150,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "CI GATE")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 435,
    y: 178,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Continuous integration")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 194,
    width: 158,
    height: 28,
    rx: 14,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 447,
    y: 213,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "secrets held: none")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 441,
    cy: 248,
    r: 2.5,
    fill: "#6B7F74"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 453,
    y: 252,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "same suite on a public runner")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 441,
    cy: 270,
    r: 2.5,
    fill: "#6B7F74"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 453,
    y: 274,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "no secret ever provisioned")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 310,
    width: 250,
    height: 94,
    rx: 10,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1,
    strokeDasharray: "6 4"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 451,
    y: 342,
    fontSize: 13,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "in-memory database")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 451,
    y: 362,
    fontSize: 12,
    fill: "#4A5F56"
  }, "created per CI run,")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 451,
    y: 379,
    fontSize: 12,
    fill: "#4A5F56"
  }, "discarded when the run ends")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 743,
    y: 256,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, "MERGE")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 711,
    y1: 270,
    x2: 772,
    y2: 270,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 782,
    y: 120,
    width: 290,
    height: 300,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 802,
    y: 150,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#16A34A"
  }, "PRODUCTION BUILD")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 802,
    y: 178,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Deploy platform")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 802,
    y: 194,
    width: 134,
    height: 28,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 1.5
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 814,
    y: 213,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12.5,
    fontWeight: 600,
    fill: "#16A34A"
  }, "secrets held: 1")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 248,
    r: 2.5,
    fill: "#6B7F74"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 252,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "the runtime database credential")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 270,
    r: 2.5,
    fill: "#6B7F74"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 274,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "already required to serve traffic")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 802,
    y: 310,
    width: 250,
    height: 94,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 336,
    fontSize: 11,
    letterSpacing: "0.1em",
    fontWeight: 600,
    fill: "#16A34A"
  }, "FAIL-CLOSED")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 358,
    fontSize: 13,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "deploy-time migration")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 377,
    fontSize: 12,
    fill: "#4A5F56"
  }, "a failed migration blocks the")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 393,
    fontSize: 12,
    fill: "#4A5F56"
  }, "release, old code keeps serving")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 536,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "The credential exists in exactly one place, the build environment that already holds it for runtime.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase5Fig2CredentialTopology);
export default __webpack_public_path__ + "static/media/case5-fig2-credential-topology.43212d9dadb82c68e4cddd75d56b7724.svg";
export { ForwardRef as ReactComponent };